<template>
  <div>
    <card class="w-100">
      <el-row :gutter="10">
        <form @submit.prevent="searchStore">
          <el-col :span="4">
            <div class="form-group">
              <label>지역</label>
              <el-select v-model="search.areaSeq" placeholder="지역 선택" @change="changeArea" :disabled="checkAuth($store.state.account.roleCode, 'EMART')">
                <el-option
                  key=""
                  label="전체"
                  value="">
                </el-option>
                <el-option
                  v-for="item in $store.state.store.areas"
                  :key="item.areaSeq"
                  :label="item.areaName"
                  :value="item.areaSeq">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="form-group">
              <label>점포</label>
              <el-select v-model="search.storeSeq" placeholder="점포 선택" filterable @change="changeStore" :disabled="checkAuth($store.state.account.roleCode, 'EMART')">
                <el-option
                  v-for="item in $store.state.store.stores"
                  :key="item.storeSeq"
                  :label="item.storeName"
                  :value="item.storeSeq">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label>매체구분</label>
              <el-select v-model="search.mediaType" @change="changeMediaType">
                <el-option
                  key=""
                  value=""
                  label="전체"></el-option>
                <el-option
                  key="WC"
                  value="WC"
                  label="와이드칼라"></el-option>
                <el-option
                  key="DM"
                  value="DM"
                  label="디지털미디어"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="pull-right-top24">
              <el-button type="primary" @click="resetPage" icon="el-icon-refresh">초기화</el-button>
              <!--<el-button type="primary" native-type="submit" icon="el-icon-search">검색</el-button>-->
            </div>
          </el-col>
        </form>
      </el-row>
    </card>
    <card class="w-100">
      <el-row :gutter="10" v-if="search.storeFloorSeq === 0">
        <el-col :span="24">
          <el-table class="table-striped"
                    border
                    style="width: 100%; margin-bottom: 10px"
                    :data="this.storeStatus"
                    :header-cell-style="tableRowStyle">
            <el-table-column
              :label="this.storeName"
              align="center">
              <el-table-column
                class-name="action-buttons td-actions"
                label="층 선택"
                width="150">
                <template slot-scope="props">
                  <el-select v-model="search.storeFloorSeq" @change="changeFloor">
                    <el-option
                      :key="0"
                      label="전체"
                      :value="0">
                    </el-option>
                    <el-option
                      v-for="item in storeFloors"
                      :key="item.storeFloorSeq"
                      :label="item.floorType === 'F' ? item.floor + item.floorType : item.floorType + item.floor"
                      :value="item.storeFloorSeq">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="전체 수량">
                <template slot-scope="props">
                  {{ props.row.totalCount | numeral('0,0')}}개
                </template>
              </el-table-column>
              <el-table-column
                label="와이드칼라 수량"
                width="150">
                <template slot-scope="props">
                  {{ props.row.wcCount | numeral('0,0')}}개
                </template>
              </el-table-column>
              <el-table-column
                label="디지털미디어 수량"
                width="150">
                <template slot-scope="props">
                  {{ props.row.dmCount | numeral('0,0')}}개
                </template>
              </el-table-column>
              <el-table-column
                label="수익">
                <template slot-scope="props">
                  {{ props.row.inComingCount | numeral('0,0')}}개
                </template>
              </el-table-column>
              <el-table-column
                label="공실">
                <template slot-scope="props">
                  {{ props.row.emptyCount | numeral('0,0')}}개
                </template>
              </el-table-column>
              <el-table-column
                label="제휴">
                <template slot-scope="props">
                  {{ props.row.affilizationCount | numeral('0,0')}}개
                </template>
              </el-table-column>
              <el-table-column
                label="PL">
                <template slot-scope="props">
                  {{ props.row.plCount | numeral('0,0')}}개
                </template>
              </el-table-column>
              <el-table-column
                label="기타">
                <template slot-scope="props">
                  {{ props.row.etcCount | numeral('0,0')}}개
                </template>
              </el-table-column>
              <el-table-column
                label="월 광고료(VAT별도)"
                width="200">
                <template slot-scope="props">
                  {{ props.row.sumPrice | numeral('0,0')}}원
                </template>
              </el-table-column>
            </el-table-column>

          </el-table>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="search.storeFloorSeq !== 0">
        <el-col :span="12" v-if="search.storeFloorSeq > 0">
          <map-component ref="map" :width="610" :read-only="true" :media-type="search.mediaType"
                         :store-seq="search.storeSeq" :store-floor-seq="search.storeFloorSeq"
                         :key="mapComponentKey"></map-component>
        </el-col>
        <el-col :span="12" class="bg-purple-light" v-if="storeStatus.length > 0">
          <el-row :gutter="12" style="color: #606266;height: 60px;text-align: center;line-height: 60px;">
            <el-col style="background: #eeeff2;border-style: solid;border-width: 1px 1px 0px 1px;border-color: #d1dbe2;"
                    :span="24">
              <div>{{this.storeName}}</div>
            </el-col>
          </el-row>
          <el-row :gutter="12" style="color: #606266;height: 60px;text-align: center;line-height: 60px;">
            <el-col style="background: #eeeff2;border-style: solid;border-width: 1px;border-color: #d1dbe2;" :span="6">
              <div>층 선택</div>
            </el-col>
            <el-col style="border-style: solid;border-width: 1px 1px 1px 0px;border-color: #d1dbe2;" :span="6">
              <el-select v-model="search.storeFloorSeq" @change="changeFloor">
                <el-option
                  :key="0"
                  label="전체"
                  :value="0">
                </el-option>
                <el-option
                  v-for="item in storeFloors"
                  :key="item.storeFloorSeq"
                  :label="item.floorType === 'F' ? item.floor + item.floorType : item.floorType + item.floor"
                  :value="item.storeFloorSeq">
                </el-option>
              </el-select>
            </el-col>
            <el-col style="background: #eeeff2;border-style: solid;border-width: 1px 1px 1px 0px;border-color: #d1dbe2;"
                    :span="6">수익
            </el-col>
            <el-col style="border-style: solid;border-width: 1px 1px 1px 0px;border-color: #d1dbe2;" :span="6">
              {{ this.storeStatus[0].inComingCount | numeral('0,0')}}개
            </el-col>
          </el-row>
          <el-row :gutter="12" style="color: #606266;height: 60px;text-align: center;line-height: 60px;">
            <el-col style="background: #eeeff2;border-style: solid;border-width: 0px 1px 1px 1px;border-color: #d1dbe2;"
                    :span="6">전체 수량
            </el-col>
            <el-col style="border-style: solid;border-width: 0px 1px 1px 0px;border-color: #d1dbe2;" :span="6">
              {{ this.storeStatus[0].totalCount | numeral('0,0')}}개
            </el-col>
            <el-col style="background: #eeeff2;border-style: solid;border-width: 0px 1px 1px 0px;border-color: #d1dbe2;"
                    :span="6">공실
            </el-col>
            <el-col style="border-style: solid;border-width: 0px 1px 1px 0px;border-color: #d1dbe2;" :span="6">
              {{ this.storeStatus[0].emptyCount | numeral('0,0')}}개
            </el-col>
          </el-row>
          <el-row :gutter="12" style="color: #606266;height: 60px;text-align: center;line-height: 60px;">
            <el-col style="background: #eeeff2;border-style: solid;border-width: 0px 1px 1px 1px;border-color: #d1dbe2;"
                    :span="6">와이드칼라 수량
            </el-col>
            <el-col style="border-style: solid;border-width: 0px 1px 1px 0px;border-color: #d1dbe2;" :span="6">
              {{ this.storeStatus[0].wcCount | numeral('0,0')}}개
            </el-col>
            <el-col style="background: #eeeff2;border-style: solid;border-width: 0px 1px 1px 0px;border-color: #d1dbe2;"
                    :span="6">제휴
            </el-col>
            <el-col style="border-style: solid;border-width: 0px 1px 1px 0px;border-color: #d1dbe2;" :span="6">
              {{ this.storeStatus[0].affilizationCount | numeral('0,0')}}개
            </el-col>
          </el-row>
          <el-row :gutter="12" style="color: #606266;height: 60px;text-align: center;line-height: 60px;">
            <el-col style="background: #eeeff2;border-style: solid;border-width: 0px 1px 1px 1px;border-color: #d1dbe2;"
                    :span="6">디지털미디어 수량
            </el-col>
            <el-col style="border-style: solid;border-width: 0px 1px 1px 0px;border-color: #d1dbe2;" :span="6">
              {{ this.storeStatus[0].dmCount | numeral('0,0')}}개
            </el-col>
            <el-col style="background: #eeeff2;border-style: solid;border-width: 0px 1px 1px 0px;border-color: #d1dbe2;"
                    :span="6">PL
            </el-col>
            <el-col style="border-style: solid;border-width: 0px 1px 1px 0px;border-color: #d1dbe2;" :span="6">
              {{ this.storeStatus[0].plCount | numeral('0,0')}}개
            </el-col>
          </el-row>
          <el-row :gutter="12" style="color: #606266;height: 60px;text-align: center;line-height: 60px;">
            <el-col style="background: #eeeff2;border-style: solid;border-width: 0px 1px 1px 1px;border-color: #d1dbe2;"
                    :span="6">월 광고료(VAT별도)
            </el-col>
            <el-col style="border-style: solid;border-width: 0px 1px 1px 0px;border-color: #d1dbe2;" :span="6">
              {{ this.storeStatus[0].sumPrice | numeral('0,0')}}원
            </el-col>
            <el-col style="background: #eeeff2;border-style: solid;border-width: 0px 1px 1px 0px;border-color: #d1dbe2;"
                    :span="6">기타
            </el-col>
            <el-col style="border-style: solid;border-width: 0px 1px 1px 0px;border-color: #d1dbe2;" :span="6">
              {{ this.storeStatus[0].etcCount | numeral('0,0')}}개
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24" v-show="listType === 'list'">
          <advertisement-list-component ref="advertisementList" :page-type="pageType"
                                        v-on:detailRow="detailRow"></advertisement-list-component>
        </el-col>
        <el-col :span="24" id="printDiv" v-show="listType === 'print'">
          <advertisement-print-component ref="advertisementPrint" :page-type="pageType"
                                         v-on:editRow="detailRow"></advertisement-print-component>
        </el-col>
        <el-col :span="14">
          <el-button type="danger" icon="el-icon-delete"
                     v-if="listType === 'list' && checkAuth($store.state.account.roleCode, 'ADMIN')"
                     v-on:click="deleteByIds">선택 삭제
          </el-button>
          <el-button type="primary" icon="el-icon-document-checked"
                     v-if="listType === 'list' && checkAuth($store.state.account.roleCode, 'ADMIN')"
                     v-on:click="showModal(true)">컬럼 선택
          </el-button>
          <el-button type="primary" icon="el-icon-plus"
                       v-if="listType === 'list' && checkAuth($store.state.account.roleCode, 'ADMIN')"
                       v-on:click="createOrder">선택항목 발주관리에 추가
            </el-button>

<!--          <el-button type="primary" icon="el-icon-finished"
                     v-if="listType === 'list' && checkAuth($store.state.account.roleCode, 'ADMIN:MANAGER:EMART:BUILDER')"
                     v-on:click="setListType('print')">출력용 화면 보기
          </el-button>-->
          <el-button type="primary" icon="el-icon-finished" v-if="listType === 'print'"
                     v-on:click="setListType('list')">리스트 화면 보기
          </el-button>
        </el-col>
        <el-col :span="10" class="pull-right">
          <div class="pull-right">
          <el-button type="primary" icon="el-icon-printer" v-if="listType === 'list' && checkAuth($store.state.account.roleCode, 'ADMIN:MANAGER:EMART:BUILDER')" v-on:click="print">프린트
          </el-button>
            <el-button type="primary" icon="el-icon-download"
                       v-if="listType === 'list'"
                       v-on:click="downloadExcel">엑셀 다운로드
            </el-button>
          </div>
        </el-col>
      </el-row>

    </card>

    <column-selector-modal ref="columnSelectorModal" :page-type="pageType" v-on:closeModal="showModal"
                           v-on:setColumn="setColumn"></column-selector-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option, Button, Row, Col, Checkbox, Card} from 'element-ui'
  import StoreProxy from "../../../../proxies/StoreProxy";
  import OrderProxy from "../../../../proxies/OrderProxy";
  import MediaProxy from "../../../../proxies/MediaProxy";
  import VueMoment from 'vue-moment'
  import vueNumeralFilterInstaller from 'vue-numeral-filter';
  import AdvertisementListComponent from "../Common/AdvertisementListComponent.vue";
  import MapComponent from "../Common/MapComponent";
  import AdvertisementPrintComponent from "../Common/AdvertisementPrintComponent";
  import ColumnSelectorModal from "../Common/ColumnSelectorModal";
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard';
  import {mapState} from "vuex";

  Vue.use(vueNumeralFilterInstaller)
  Vue.use(VueMoment)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Button)
  Vue.use(Row)
  Vue.use(Col)
  Vue.use(Checkbox)
  Vue.use(Card)

  window.updateCompleteStore = function() {
    let areaSeq = localStorage.getItem("areaSeq");
    let storeSeq = localStorage.getItem("storeSeq");
    let mediaType = localStorage.getItem("mediaType");
    let storeFloorSeq = localStorage.getItem("storeFloorSeq");
    localStorage.setItem("reload", "true");
    location.href = "/#/store/status?areaSeq="+areaSeq+"&storeSeq="+storeSeq+"&mediaType="+mediaType+"&storeFloorSeq="+storeFloorSeq;
    location.reload();
  };

  export default {
    name: "Status",
    created: function () {
      this.$store.dispatch('common/setMenuTitle', "점포 현황");
      this.$store.dispatch('store/getAreaList');
      this.$store.dispatch('store/initStoreMediaList');
      this.$store.dispatch('store/findAll', {searchAreaSeq: ''});
      if(this.$store.state.account.roleCode === "EMART") {
        this.search.storeSeq = this.$store.state.account.companySeq;
        this.changeStore();
      }

      if(localStorage.getItem("reload") === "true") {
        if(this.$route.query.areaSeq !== "") {
          this.search.areaSeq = parseInt(this.$route.query.areaSeq);
        }
        if(this.$route.query.storeSeq !== "") {
          this.search.storeSeq = parseInt(this.$route.query.storeSeq);
        }
        this.search.mediaType = this.$route.query.mediaType;
        // this.search.storeFloorSeq = parseInt(this.$route.query.storeFloorSeq);
        this.listType = "list";
        this.reload(parseInt(this.$route.query.storeFloorSeq));
        localStorage.setItem("reload", "false");
      }
    },
    components: {
      AdvertisementListComponent,
      MapComponent,
      AdvertisementPrintComponent,
      ColumnSelectorModal,
      StatsCard,
    },
    methods: {
      tableRowStyle() {
        return this.$store.state.common.tableHeaderCellStyle;
      },
      // 지역 변경
      changeArea(value) {
        this.store = [];
        this.storeStatus = [];
        this.$refs.advertisementList.resetList();
        this.storeName = '';
        this.storeFloors = '';
        this.search.storeSeq = '';
        this.search.storeFloorSeq = 0;
        let param = {
          searchAreaSeq: value
        };
        this.$store.dispatch('store/findAll', param);
      },
      // 전포현황 조회
      searchStore() {
        if (this.search.storeSeq === "") {
          alert("점포를 선택하세요.");
        } else {
          this.store = [];
          new StoreProxy()
            .find(this.search.storeSeq)
            .then((response) => {
              this.store.push(response.store);
              this.storeName = response.store.storeName + "점 운영 현황";
              this.storeFloors = response.storeFloors;
              this.getStoreStatus(this.search.storeSeq, this.search.storeFloorSeq);
            });
        }
      },
      // 매장 현황 조회
      getStoreStatus(storeSeq, storeFloorSeq) {

        let param = {
          mediaType: this.search.mediaType
        };
        new StoreProxy(param)
          .getStoreStatus(storeSeq, storeFloorSeq)
          .then((response) => {
            this.storeStatus = [];
            this.storeStatus.push(response.storeStatus);
          });
        this.$refs.advertisementList.getList(this.search);
      },
      reload(storeFloorSeq) {
        this.store = [];
        this.storeStatus = [];
        new StoreProxy()
          .find(this.search.storeSeq)
          .then((response) => {
            this.store.push(response.store);
            this.storeName = response.store.storeName + "점 운영 현황";
            this.storeFloors = response.storeFloors;
            if(storeFloorSeq > 0) {
              this.changeFloor(storeFloorSeq);
            } else {
              this.getStoreStatus(this.search.storeSeq, this.search.storeFloorSeq);
            }
          });
      },
      // 층 전환
      changeFloor(value) {
        this.search.storeFloorSeq = value;
        this.getStoreStatus(this.search.storeSeq, this.search.storeFloorSeq);
        this.forceRerender();
        this.setListType(this.listType);
      },
      // 발주관리에 추가
      createOrder() {
        this.multipleSelection = this.$refs.advertisementList.getMultipleSelections();
        if (this.multipleSelection.length > 0) {
          if (confirm("선택한 항목을 발주관리에 추가하시겠습니까?")) {
            let advertisementArray = [];
            this.multipleSelection.forEach(s => {
              advertisementArray.push({advertisementSeq: s.advertisement_seq})
            });
            new OrderProxy()
              .create({advertisements: advertisementArray})
              .then((response) => {
                if (response.header.returnCode === "OK") {
                  alert("완료되었습니다.")
                } else {
                  alert(response.header.resultMessages);
                }
              })
          }
        } else {
          alert("광고를 선택하세요.");
        }
      },
      // 선택광고 엑셀 다운로드
      downloadExcel() {
        this.multipleSelection = this.$refs.advertisementList.getMultipleSelections();
        if (this.multipleSelection.length > 0) {
          let param = "";
          this.multipleSelection.forEach(s => {
            param += s.advertisement_seq + ",";
          });
          location.href = "/api/store/excel?authorization=" + $cookies.get('id_token') + "&list=" + param;
        } else {
          alert("광고를 선택하세요.");
        }
      },
      deleteByIds() {
        this.multipleSelection = this.$refs.advertisementList.getMultipleSelections();
        if (this.multipleSelection.length > 0) {
          if (confirm("선택한 광고를 삭제하시겠습니까?")) {
            let param = "";
            this.multipleSelection.forEach(s => {
              param += s.advertisement_seq + ",";
            });
            new MediaProxy({list: param})
              .deleteByIds()
              .then((response) => {
                this.getStoreStatus(this.search.storeSeq, this.search.storeFloorSeq);
              })
          }
        } else {
          alert("광고를 선택하세요.");
        }
      },
      // 광고 상세 조회
      detailRow(row) {
        if (this.$store.state.account.roleCode === 'ADMIN') {
          localStorage.setItem("areaSeq", this.search.areaSeq);
          localStorage.setItem("storeSeq", this.search.storeSeq);
          localStorage.setItem("mediaType", this.search.mediaType);
          localStorage.setItem("storeFloorSeq", this.search.storeFloorSeq);
          window.open("/#/store/" + this.search.storeSeq + "/advertisement/" + row.advertisement_seq + "?page=store&area_seq=" + this.search.areaSeq + "&id_token=" + $cookies.get('id_token'), "media_edit" + row.advertisement_seq, "width=820, height=1000, status=1, scrollbars=1");
        } else {
          window.open("/#/advertiser/store/" + this.search.storeSeq + "/floor/" + row.store_floor_seq + "/advertisement/" + row.advertisement_seq + "?media_type=" + row.media_type + "&page_type=storeStatus" + "&id_token=" + $cookies.get('id_token'), "media_detail" + row.advertisement_seq, "width=820, height=1000, status=1, scrollbars=1");
        }
      },
      // 대상 확인창 열기/닫기
      showModal(isShow) {
        this.modals.isShow = isShow;
        if (isShow) {
          this.updateColumn();
          this.$refs.columnSelectorModal.show();
        }
      },
      // 컬럼선택 완료
      setColumn() {
        this.$refs.advertisementList.findAllByUserIdAndPageType(this.pageType);
        this.showModal(false);
      },
      // 컬럼선택 창에서 컬럼설정 다시 조회
      updateColumn() {
        this.$refs.columnSelectorModal.findAllByUserIdAndPageType();
      },
      // 매장 선택
      changeStore() {
        this.search.storeFloorSeq = 0;
        this.listType = "list";
        this.searchStore();
      },
      // 매체구분 전환
      changeMediaType() {
        this.searchStore();
        this.forceRerender();
        this.setListType(this.listType);
      },
      // 지도 강제 랜더링 처리
      forceRerender() {
        this.mapComponentKey += 1;
      },
      // 리스트형 / 출력형 전환 기능
      setListType(type) {
        if ((this.search.storeFloorSeq === 0 || this.search.mediaType === '') && type === "print") {
          alert("층과 매체구분을 선택한 경우만 사용이 가능합니다.");
        } else {
          this.listType = type;
          if (this.listType === "print") {
            this.search.sortColumn = "m.position_number, m.position_code";
            this.search.sortOrder = "ascending";
            this.$refs.advertisementPrint.getList(this.search);
          }
        }
      },
      // 프린터
      print() {
        if ((this.search.storeFloorSeq === 0 || this.search.mediaType === '')) {
          alert("층과 매체구분을 선택한 경우만 사용이 가능합니다.");
        } else {
          let size = this.$refs.advertisementList.getListSize();
          window.open("/#/store/status/print?size=" + size + "&sortColumn=" + this.search.sortColumn + "&sortOrder=" + this.search.sortOrder + "&storeSeq=" + this.search.storeSeq + "&storeFloorSeq=" + this.search.storeFloorSeq + "&mediaType=" + this.search.mediaType, "my_window", "width=820, height=1000, status=1, scrollbars=1");
        }
      },
      // 화면 초기화
      resetPage() {
        location.reload();
      },
      // 권한 확인
      checkAuth(roleCode, targetRoles) {
        return Vue.checkAuth(roleCode, targetRoles);
      }
    },
    computed: {
      detailColumn() {
        return this.columns.filter(function (c) {
          return c.show && c.id !== 'image';
        })
      },
    },
    data() {
      return {
        row: {
          align: "bottom"
        },
        listType: "list",
        selectAdvertisement: {
          advertisementSeq: ''
        },
        search: {
          areaSeq: '',
          mediaType: '',
          storeSeq: '',
          storeFloorSeq: 0,
          sortColumn: '',
          sortOrder: '',
        },
        store: [],
        storeFloors: [],
        storeStatus: [],
        storeName: '',
        multipleSelection: [],
        modals: {
          isShow: false,
        },
        columns: [],
        pageType: 'storeStatus',
        mapComponentKey: 0,
      }
    },
  }
</script>

<style>
  .el-select .el-input:hover .el-input__icon, .el-select .el-input:hover input {
    color: #212529 !important;
  }

  .bg-purple-light {
    background: #f8f9fc;
  }
</style>
